import AppBar from "@mui/material/AppBar";
import Stack from "@mui/material/Stack";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import { useInvalidate, useLogout } from "@refinedev/core";
import React from "react";
import { LogoutOutlined } from "@mui/icons-material";
import { Container, IconButton, Link } from "@mui/material";
import { useAuthStore } from "../../authProvider";
import logo from "../../assets/logo_transparent_white.png";

export const ClientHeader: React.FC = () => {
  const { user } = useAuthStore();
  const invalidate = useInvalidate();
  const { mutate: logout } = useLogout();

  return (
    <AppBar
      position="sticky"
      sx={{
        backgroundColor: "#191919",
        height: "64px",
      }}
    >
      <Container maxWidth="lg" sx={{ height: "100%" }}>
        <Toolbar sx={{ height: "100%" }}>
          <Stack
            direction="row"
            width="100%"
            alignItems="center"
            justifyContent="space-between"
          >
            <Stack direction="row" alignItems="center">
              <Link
                href="https://www.fashionwords.eu/"
                target="_blank"
                rel="noopener noreferrer"
                sx={{ display: "flex", alignItems: "center" }}
              >
                <img
                  src={logo}
                  alt="Fashion Words Logo"
                  style={{
                    maxWidth: "100px",
                    height: "auto",
                    objectFit: "contain",
                  }}
                />
              </Link>
            </Stack>

            <Stack direction="row" alignItems="center" spacing={2}>
              {user?.name && (
                <Stack direction="row" spacing={1} alignItems="center">
                  <Typography
                    variant="subtitle2"
                    sx={{
                      color: "white",
                      cursor: "default",
                      fontFamily: "Rubik, sans-serif",
                    }}
                  >
                    {user.name} {user.surname}
                  </Typography>
                </Stack>
              )}
              <IconButton
                color="primary"
                sx={{ color: "white", "&:hover": { color: "#D9D9D9" } }}
                onClick={() => {
                  invalidate({
                    resource: "*",
                    invalidates: ["all", "resourceAll"],
                  });
                  logout();
                }}
                aria-label="logout"
              >
                <LogoutOutlined />
              </IconButton>
            </Stack>
          </Stack>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default ClientHeader;
